// removed by extract-text-webpack-plugin
module.exports = {"heroSkinny":"src-components-modules-Hero-HeroSkinny-style----general-module---heroSkinny---1b0Wf paddingBottom-l","center":"src-components-modules-Hero-HeroSkinny-style----general-module---center---3anwV textAlign-center"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Hero/HeroSkinny/style/general.module.css
// module id = 1476
// module chunks = 168707334958949